module.exports = __webpack_public_path__ + "ecb630b74e613ecc1cfe618d79e3b9fa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/log-cabin.png
// module id = 579
// module chunks = 0